export const isValid=(value,valids)=>{
  return valids.indexOf(value)>=0
}

export const randomFrom=choices=>{
  if (Array.isArray(choices)&&choices.length>0) {
    const ind = Math.floor(Math.random()*choices.length)
    return choices[ind]
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/component/util/Util.js